import { render, staticRenderFns } from "./AccrualHistoryTable.vue?vue&type=template&id=4531d770&"
import script from "./AccrualHistoryTable.vue?vue&type=script&lang=js&"
export * from "./AccrualHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports